import React, { memo, useContext } from "react";
import { Videocam } from "@mui/icons-material";
import { AuthContext } from "../../../context/Auth/AuthContext";
import { getFlowMediaPublicUrl } from "../../../utils/flowMediaUrl";
import NodeWrapper from "./NodeWrapper";

const VideoNode = memo(({ id, data, isConnectable, selected }) => {
  const { user } = useContext(AuthContext);
  const hasUrl = !!data?.url;
  const previewSrc = hasUrl ? getFlowMediaPublicUrl(data.url, user?.companyId) : null;

  return (
    <NodeWrapper
      id={id}
      data={data}
      icon={<Videocam />}
      title="Video"
      color="#22c55e"
      bgColor="#F0FFF4"
      isConnectable={isConnectable}
      selected={selected}
    >
      {hasUrl && previewSrc ? (
        <video
          controls
          width="180"
          style={{ borderRadius: 6, maxHeight: 100, background: "#000" }}
        >
          <source src={previewSrc} type="video/mp4" />
        </video>
      ) : hasUrl ? (
        <div
          style={{
            display: "inline-flex",
            alignItems: "center",
            gap: 4,
            padding: "4px 10px",
            borderRadius: 20,
            fontSize: 11,
            fontWeight: 600,
            backgroundColor: "#E8F5E9",
            color: "#2e7d32",
            border: "1px solid #22c55e30",
          }}
        >
          <Videocam style={{ fontSize: 13 }} />
          Video
        </div>
      ) : (
        <div
          style={{
            fontSize: 11,
            color: "#999",
            fontStyle: "italic",
            padding: "4px 0",
          }}
        >
          Enviar video
        </div>
      )}
    </NodeWrapper>
  );
});

VideoNode.displayName = "VideoNode";
export default VideoNode;
